import Sako from "./Sako"
import Jawaab from "./Jawaab"
import Loading from "./Loading"
import {Usedata} from "./Context/Allcontext"


function SakoModel(){
    const {AcSako, AcJawaab , AcLoading} = Usedata()
    return(
        <>
         {/* <audio src="/Media/notification_sound.mp3" /> */}
    {/* <!----------- sako model  -------------------> */}
    {AcSako && (
    <section className="overley sako active">
    <div className="haye">
        <div className="sako_model">
            {/* sako_mode */}
            <Sako />
        </div>
    </div>
    </section>
    )}

    {AcJawaab && (
    <section className="overley sako active">
    <div className="haye">
        <div className="sako_model">
            {/* jawaa_model */}
            <Jawaab />
        </div>
    </div>
    </section>
    )}

    {AcLoading && (
    <section className="overley sako active">
    <div className="haye">
        <div className="sako_model">
            <Loading />
        </div>
    </div>
    </section>
    )}
        </>
    )
}


export default SakoModel